import RichText from "@/components/RichText";

// Detects if a string looks like authored HTML from the RichTextEditor. Older
// seed data comes in as plain text — we handle both without a data migration.
function isProbablyHtml(str) {
  return typeof str === "string" && /<\w+[\s>]/i.test(str);
}

/**
 * Renders a body/subtitle field that may be HTML (from the RichTextEditor) or
 * plain text (from legacy seed data / old CMS records).
 *
 * Props:
 *   value           — the field value (string, may be HTML or plain text)
 *   proseClassName  — Tailwind classes for the HTML variant
 *   plainClassName  — Tailwind classes for the plain-text variant
 *   testId          — optional data-testid
 *
 * Returns `null` for empty / undefined values so callers can nest safely.
 */
export default function BlockProse({
  value,
  proseClassName,
  plainClassName,
  testId,
}) {
  if (!value) return null;
  if (isProbablyHtml(value)) {
    return <RichText html={value} className={proseClassName} testId={testId} />;
  }
  return (
    <p className={plainClassName} data-testid={testId}>
      {value}
    </p>
  );
}
